// Escolhe o campo do valor de cada produto pelo tipo da promoção: Valor Fixo →
// "De R$ X por R$ ___"; % de Desconto → "De R$ X com __% de desconto = R$ Y".
import DescontoPct from "./DescontoPct";
import PrecoPor from "./PrecoPor";

const CAMPOS = { fixed_price: PrecoPor, percentage: DescontoPct };

export default function CampoDesconto({ tipo, ...props }) {
  const Campo = CAMPOS[tipo];
  return Campo ? <Campo {...props} /> : null;
}

CampoDesconto.atende = (tipo) => !!CAMPOS[tipo];
